<template>
    <div class="module module-info">
        <h1 style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold ">
            4 DATOS DEL DISPOSITIVO
        </h1>
        <br /><br />
        <br /><br />
        <h3 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal ">Dispositivo indicado por el cliente</h3>
        <div v-if="tieneEstadoEsperado">
            <p class="text--smaller">Fabricante: {{this.$bus.pConsulta.datosOrden.TERMINALES.ESPERADO.FABRICANTE}}</p>
            <p class="text--smaller">Familia: {{this.$bus.pConsulta.datosOrden.TERMINALES.ESPERADO.FAMILIA}}</p>
            <p class="text--smaller">Tipo de dispositivo: {{this.$bus.pConsulta.datosOrden.TERMINALES.ESPERADO.TIPO_MODELO}}</p>
            <p class="text--smaller">Serie: {{this.$bus.pConsulta.datosOrden.TERMINALES.ESPERADO.MODELO_PADRE | modeloPadre}}</p>
            <p class="text--smaller">Modelo: {{this.$bus.pConsulta.datosOrden.TERMINALES.ESPERADO.MODELO}}</p>
            <p class="text--smaller">SN: {{this.$bus.pConsulta.datosOrden.TERMINALES.ESPERADO.SN}}</p>
        </div>
        <h3 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal "> Dispositivo cotejado en el centro de reparacion</h3>
        <div v-if="tieneEstadoEntrada">
            <p class="text--smaller">Fabricante: {{this.$bus.pConsulta.datosOrden.TERMINALES.ENTRADA.FABRICANTE}}</p>
            <p class="text--smaller">Familia: {{this.$bus.pConsulta.datosOrden.TERMINALES.ENTRADA.FAMILIA}}</p>
            <p class="text--smaller">Tipo de dispositivo: {{this.$bus.pConsulta.datosOrden.TERMINALES.ENTRADA.TIPO_MODELO}}</p>
            <p class="text--smaller">Serie: {{this.$bus.pConsulta.datosOrden.TERMINALES.ENTRADA.MODELO_PADRE | modeloPadre}}</p>
            <p class="text--smaller">Modelo: {{this.$bus.pConsulta.datosOrden.TERMINALES.ENTRADA.MODELO}}</p>
            <p class="text--smaller">SN: {{this.$bus.pConsulta.datosOrden.TERMINALES.ENTRADA.SN}}</p>
        </div>
        <div class="mt-3" v-else>
            <v-alert class="green-alert" type="warning" outlined>
                El dispositivo aun no se ha recibido en el centro de reparacion
            </v-alert>
        </div>
        <h3 style="font-family: Heebo; font-size: 26px; color: black; font-weight: normal ">Dispositivo final reparado</h3>
        <div v-if="tieneEstadoSalida">
            <p class="text--smaller">Fabricante: {{this.$bus.pConsulta.datosOrden.TERMINALES.SALIDA.FABRICANTE}}</p>
            <p class="text--smaller">Familia: {{this.$bus.pConsulta.datosOrden.TERMINALES.SALIDA.FAMILIA}}</p>
            <p class="text--smaller">Tipo de dispositivo: {{this.$bus.pConsulta.datosOrden.TERMINALES.SALIDA.TIPO_MODELO}}</p>
            <p class="text--smaller">Serie: {{this.$bus.pConsulta.datosOrden.TERMINALES.SALIDA.MODELO_PADRE | modeloPadre}}</p>
            <p class="text--smaller">Modelo: {{this.$bus.pConsulta.datosOrden.TERMINALES.SALIDA.MODELO}}</p>
            <p class="text--smaller">SN: {{this.$bus.pConsulta.datosOrden.TERMINALES.SALIDA.SN}}</p>
        </div>
        <div v-else>
            <v-alert class="green-alert" type="warning" outlined>
                Aun no ha finalizado el proceso de reparacion del dispositivo
            </v-alert>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            tieneEstadoEsperado() {
                return Object.keys(this.$bus.pConsulta.datosOrden.TERMINALES).includes('ESPERADO') && Object.keys(this.$bus.pConsulta.datosOrden.TERMINALES.ESPERADO).length !== 0
            },
            tieneEstadoEntrada() {
                return Object.keys(this.$bus.pConsulta.datosOrden.TERMINALES).includes('ENTRADA') && Object.keys(this.$bus.pConsulta.datosOrden.TERMINALES.ENTRADA).length !== 0
            },
            tieneEstadoSalida() {
                return Object.keys(this.$bus.pConsulta.datosOrden.TERMINALES).includes('SALIDA') && Object.keys(this.$bus.pConsulta.datosOrden.TERMINALES.SALIDA).length !== 0
            },
        },
        filters: {
            modeloPadre: function (val) {
                if (val == '' || val == null || val == 0 || val == undefined) return 'Ninguna'
                else return val
           }
        },
  }
</script>
<style lang="scss">
    .green-alert{
        color: #9be51a !important;
        background-color: white !important;
    }
</style>